import { render, staticRenderFns } from "./u-parse.vue?vue&type=template&id=9b4d0a4c&scoped=true"
import script from "./u-parse.vue?vue&type=script&lang=js"
export * from "./u-parse.vue?vue&type=script&lang=js"
import style0 from "./u-parse.vue?vue&type=style&index=0&id=9b4d0a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4d0a4c",
  null
  
)

export default component.exports